export const urls = {
  LANDING_PAGE_PATH: "/",
  LANDING_PAGE_ACADEMY: "/academy",
  LANDING_PAGE_COURSES: "/courses",
  LANDING_PAGE_GPC_COURSE: "/gpc-course/:category/:id",
  LANDING_PAGE_MSIB_BOOTCAMP: "/intensive-bootcamp/:category/:id",
  LANDING_PAGE_JOB_GUARANTEE_BOOTCAMP: "/job-guarantee-bootcamp/:category/:id(\\d+|trial)?",
  LANDING_PAGE_JOB_GUARANTEE_BOOTCAMP_TRIAL: "/job-guarantee-bootcamp/:category/trial",
  LANDING_PAGE_OFFLINE_BOOTCAMP: "/offline-bootcamp/:category/",
  LANDING_PAGE_MINI_INTENSIVE_COURSE: "/mini-intensive-course/:category/:id?",
  LANDING_PAGE_FREE_CLASS: "/free-class/:category/:id?",
  LANDING_PAGE_PRAKERJA: "/prakerja",
  LANDING_PAGE_PRAKERJA_ADS: "/prakerja/ads",
  LANDING_PAGE_PRAKERJA_DETAIL: "/prakerja/:category/:id?",
  LANDING_PAGE_JAP: "/job-acceleration-program/:category/:id",
  LANDING_PAGE_CAREER_PROFILER: "/career-profiler",
  LANDING_PAGE_RAKAMIN_TUTOR: "/rakamin-tutor",
  LANDING_PAGE_JAP_FOR_CAMPUS: "/jap-for-campus",
  LANDING_PAGE_PROGRAM: "/programs/:category",
  LANDING_PAGE_PREMIUM_BOOTCAMP: "/intensive/job-guarantee-bootcamp/:category?",

  LANDING_PAGE_PRODUCTS: "/products",
  LANDING_PAGE_HIRING_PLATFORM: "/products/hiring-platform",
  LANDING_PAGE_ASSESSMENT: "/products/assessment",
  LANDING_PAGE_LMS: "/products/lms",
  LANDING_PAGE_TALENT_INTELLIGENCE: "/products/talent-intelligence",

  JOB_PORTAL: "/jobs",
  JOB_DETAIL: "/jobs/:job_vacancy_id",
  EXPLORE_OPPORTUNITIES: "/explore-opportunities",
  EXPLORE_OPPORTUNITIES_STAGE: "/explore-opportunities/:stage",
  CAREER_PATH: "/career-path",
  REFUND_POLICIES: "/refund-policies",
  FAQ: "/faq",
  LOGIN_PATH: "/login",
  LOGIN_PASSWORD_PATH: "/login/password",
  REGISTER_PATH: "/register",
  USER_PREFERENCE_SURVEY: "/user-preference-survey",
  FORGOT_PASSWORD_PATH: "/forgot-password",
  LANDING_PAGE_RESET_PASSWORD_PATH: "/reset-password",
  CHECKOUT: "/checkout",
  CHECKOUT_INSTALLMENT_FORM: "/checkout/installment-form",
  ABOUT_US: "/about-us",
  TESTIMONIAL: "/testimonial",
  WORKFORCE: "/workforce",
  IMPACT_THESIS: "/impact-thesis",
  WORKFORCE_FORM: "/workforce-form",
  ROI_CALCULATOR: "/roi-calculator",
  ACCOUNT_VERIFICATION: "/account-verification",
  LOGIN_LINK_VERIFICATION: "/login-link",

  CORPORATE_TALENT_TRANSFORMATION: "/for-corporate/corporate-talent-transformation",
  TALENT_HIRING: "/for-corporate/talent-hiring",
  TALENT_PROFILE: "/profile/:address",

  DASHBOARD_PATH: "/dashboard",
  DASHBOARD_MYCLASS: "/dashboard/my-class/:course_id",
  DASHBOARD_MYCLASS_HIGHLIGHT: "/dashboard/my-class/:course_id/highlight",
  DASHBOARD_JOB_ACCELERATION: "/dashboard/job-acceleration/:course_id",
  DASHBOARD_JOB_GUARANTEE: "/dashboard/job-guarantee/:course_id",
  DASHBOARD_MYCLASS_CERTIFICATE_GRADEBOOK: "/dashboard/my-class/:course_id/certificate",
  DASHBOARD_MYCLASS_ATTENDANCE_HISTORY: "/dashboard/my-class/:course_id/attendance-history",
  DASHBOARD_MYCLASS_ASSIGNMENT_HISTORY: "/dashboard/my-class/:course_id/assignment-history",
  DASHBOARD_MYCLASS_MODULE: "/dashboard/my-class/:course_id/module/:module_id/session/:session_id",
  DASHBOARD_MANAGE_USER: "/dashboard/manage-users",
  DASHBOARD_PROFILE: "/dashboard/profile",
  DASHBOARD_PROFILE_TALENT_DATA: "/dashboard/profile/talent-data",
  DASHBOARD_PROFILE_VIRTUAL_INTERNSHIP: "/dashboard/profile/virtual-internship",
  DASHBOARD_PROFILE_WORK_EXPERIENCE: "/dashboard/profile/work-experience",
  DASHBOARD_PROFILE_EDUCATION: "/dashboard/profile/education-training",
  DASHBOARD_PROFILE_HIRING_PROCESS: "/dashboard/profile/hiring-process",
  DASHBOARD_PROFILE_PORTFOLIO: "/dashboard/profile/portfolio",
  DASHBOARD_PROFILE_ASSESSMENT: "/dashboard/profile/assessment",
  DASHBOARD_PROFILE_DOCUMENTS: "/dashboard/profile/documents",
  DASHBOARD_PROFILE_REFERRAL: "/dashboard/profile/referral",
  DASHBOARD_PROFILE_TALENT_PROFILER: "/dashboard/profile/talent-profiler",
  DASHBOARD_LEARNING: "/dashboard/learning",
  DASHBOARD_LEARNING_COURSE_DETAIL: "/dashboard/learning/course-detail",
  DASHBOARD_LEARNING_COMPLETION_RATE: "/dashboard/learning/completion-rate",
  DASHBOARD_COURSE_PATH: "/dashboard/courses",
  DASHBOARD_COURSE_ENROLLED: "/dashboard/courses/enrolled",
  DASHBOARD_COURSE_COMPLETED: "/dashboard/courses/completed",
  DASHBOARD_ADMIN_SCORING_TEMPLATE: "/dashboard/scoring-template",
  DASHBOARD_SCORECARD_PATH: "/dashboard/scorecard",
  DASHBOARD_ADMIN_LEADERBOARD: "/dashboard/leaderboard",
  DASHBOARD_ADMIN_COURSE_LIST: "/dashboard/course-list",
  DASHBOARD_ADMIN_CLASS_SETTING: "/dashboard/class-setting/:course_id",
  DASHBOARD_ADMIN_BASIC_INFO: "/dashboard/class-setting/add/basic-info",
  DASHBOARD_ADMIN_BASIC_INFO_EDIT: "/dashboard/class-setting/:course_id/basic-info",
  DASHBOARD_ADMIN_ENROLLED_STUDENT: "/dashboard/class-setting/:course_id/enrolled-student",
  DASHBOARD_ADMIN_MODULES: "/dashboard/class-setting/:course_id/modules/:module_id",
  DASHBOARD_ADMIN_SURVEYS_CLASS_SETTINGS: "/dashboard/class-setting/:course_id/surveys",
  DASHBOARD_ADMIN_ASSESSMENTS: "/dashboard/class-setting/:course_id/assessments",
  DASHBOARD_ADMIN_ATTENDANCE: "/dashboard/class-setting/:course_id/attendances",
  DASHBOARD_ADMIN_FINAL_SCORING: "/dashboard/class-setting/:course_id/final-scoring",
  DASHBOARD_ADMIN_MENTORING_SCORING: "/dashboard/class-setting/:course_id/mentoring-scoring",
  DASHBOARD_TALENTS_LIST: "/dashboard/talents-list",
  DASHBOARD_TALENT_DETAILS: "/dashboard/talent/:talent_id",
  DASHBOARD_TALENT_DETAILS_TALENT_DATA: "/dashboard/talent/:talent_id/talent-data",
  DASHBOARD_TALENT_DETAILS_VIRTUAL_INTERNSHIP: "/dashboard/talent/:talent_id/virtual-internship",
  DASHBOARD_TALENT_DETAILS_WORK_EXPERIENCE: "/dashboard/talent/:talent_id/work-experience",
  DASHBOARD_TALENT_DETAILS_EDUCATION: "/dashboard/talent/:talent_id/education-training",
  DASHBOARD_TALENT_DETAILS_HIRING_PROCESS: "/dashboard/talent/:talent_id/hiring-process",
  DASHBOARD_TALENT_DETAILS_PORTFOLIO: "/dashboard/talent/:talent_id/portfolio",
  DASHBOARD_TALENT_DETAILS_ASSESSMENT: "/dashboard/talent/:talent_id/assessment",
  DASHBOARD_TALENT_DETAILS_DOCUMENTS: "/dashboard/talent/:talent_id/documents",
  DASHBOARD_TALENT_DETAILS_REFERRAL: "/dashboard/talent/:talent_id/referral",
  DASHBOARD_TALENT_DETAILS_TALENT_PROFILER: "/dashboard/talent/:talent_id/talent-profiler",
  DASHBOARD_HOMEWORK_EXAM: "/dashboard/homework-exam/:module_session_id",
  DASHBOARD_HOMEWORK_EXAM_VIX: "/dashboard/homework-exam/vix/:module_session_id",
  DASHBOARD_HOMEWORK_EXAM_MINI_PROJECT: "/dashboard/homework-exam/mini-project/:module_session_id",
  DASHBOARD_ADMIN_ASSIGNMENT_BUILDER: "/dashboard/assignment-builder/:session_id",
  DASHBOARD_ADMIN_SURVEY: "/dashboard/survey",
  DASHBOARD_ADMIN_EDIT_SURVEY: "/dashboard/survey/:survey_id/edit",
  DASHBOARD_ADMIN_VIEW_SURVEY: "/dashboard/survey/:survey_id/detail",
  DASHBOARD_ADMIN_SURVEY_TEMPLATE: "/dashboard/survey/template",
  DASHBOARD_ADMIN_SURVEY_ASSIGN: "/dashboard/survey/assign",
  DASHBOARD_ADMIN_CLASS_SURVEYS: "/dashboard/class-setting/:course_id/class-surveys",
  DASHBOARD_PAYMENT_LIST: "/dashboard/payment-list",
  DASHBOARD_VIRTUAL_INTERNSHIP: "/dashboard/virtual-internship",
  DASHBOARD_VIRTUAL_INTERNSHIP_BUILDER: "/dashboard/virtual-internship/builder/:id",
  DASHBOARD_ASSESSMENT: "/dashboard/assessments",
  DASHBOARD_ASSESSMENT_ITEM: "/dashboard/assessment-item",
  DASHBOARD_ASSIGNMENT_SCORING: "/dashboard/scoring/:assignment_id",
  DASHBOARD_UPLOADER: "/dashboard/file-uploader",
  DASHBOARD_LOCALE_EDITOR: "/dashboard/locale-editor",
  DASHBOARD_IMPORT_USER_DATA: "/dashboard/import-user-data",
  DASHBOARD_TALENT_PROFILER: "/dashboard/talent-profiler",
  DASHBOARD_PBI: "/dashboard/project-based-internship",
  DASHBOARD_REWARD: "/dashboard/reward",
  DASHBOARD_INVITE_AND_ASSESS: "/dashboard/invite-and-assess",
  DASHBOARD_CUSTOM_EMAIL_DETAIL: "/dashboard/custom-email/:id",

  DOWNLOAD_PATH: "/download",
  DOWNLOAD_ASSESSMENT_RESULT: "/download/assessment-result",
  DOWNLOAD_INVOICE: "/download/invoice/:invoice_id",
  DOWNLOAD_RECEIPT: "/download/receipt/:receipt_id",
  DOWNLOAD_CV: "/download/talent-cv/:user_vwxes_id",
  PRIVACY_POLICY: "/privacy-policy",
  DOWNLOAD_ASSESSMENT_REPORT:
    "/download/assessment-report/:user_id/:course_id/:job_vacancy_assessment_id",

  PROJECT_BASED_INTERNSHIP: "/project-based-internship",
  VIRTUAL_WORKING_EXPERIENCE: "/virtual-internship-experience",
  VIRTUAL_WORKING_EXPERIENCE_ABOUT_VIP: "/about-project-based-internship",
  VIRTUAL_WORKING_EXPERIENCE_ABOUT_VIP_2: "/virtual-internship-experience/about-vip-access",
  VIRTUAL_WORKING_EXPERIENCE_EXPLORE: "/virtual-internship-experience/explore",
  VIRTUAL_WORKING_EXPERIENCE_DETAIL: "/virtual-internship-experience/:vwx_id",
  VIRTUAL_WORKING_EXPERIENCE_TASK: "/virtual-internship-experience/task/:vwx_id/:task_id",
  VIRTUAL_WORKING_EXPERIENCE_BIODATA: "/virtual-internship-experience/biodata",

  HIRING_DASHBOARD: "/hiring-dashboard",
  HIRING_DASHBOARD_OUTSOURCING: "/hiring-dashboard/outsourcing",
  HIRING_DASHBOARD_PBI: "/hiring-dashboard/project-based-internship",
  HIRING_DASHBOARD_CUSTOM_EMAIL: "/hiring-dashboard/custom-email",
  HIRING_DASHBOARD_INJECT_ASSESSMENT_RESULT: "/hiring-dashboard/inject-assessment-result",
  HIRING_DASHBOARD_ARTICLES: "/hiring-dashboard/articles",
  HIRING_DASHBOARD_ARTICLES_TRASH: "/hiring-dashboard/articles/trash",
  HIRING_DASHBOARD_ARTICLE_EDITOR: "/hiring-dashboard/articles/:article_id",
  HIRING_DASHBOARD_WEBSITE_CONTENT: "/hiring-dashboard/website-content",
  HIRING_DASHBOARD_MATCHMAKING_SETTINGS: "/hiring-dashboard/settings/matchmaking",
  HIRING_DASHBOARD_CUSTOM_EMAIL_DETAIL: "/hiring-dashboard/custom-email/:id",
  HIRING_DASHBOARD_TALENT_SCOUTING: "/hiring-dashboard/talent-scouting",
  HIRING_DASHBOARD_TALENT_SCOUTING_LIST: "/hiring-dashboard/talent-scouting/list",
  HIRING_DASHBOARD_TALENT_SCOUTING_POOL: "/hiring-dashboard/talent-scouting/pool",
  HIRING_DASHBOARD_TALENT_SCOUTING_BLACKLIST: "/hiring-dashboard/talent-scouting/blacklist",
  HIRING_DASHBOARD_TALENT_SCOUTING_INTERNAL_MOBILITY:
    "/hiring-dashboard/talent-scouting/internal-mobility-candidates",
  HIRING_DASHBOARD_TALENT_SCOUTING_MANAGE:
    "/hiring-dashboard/talent-scouting/manage/:job_vacancy_id",
  HIRING_DASHBOARD_TALENT_SCOUTING_MANAGE_MATCH_RATE_SETTING:
    "/hiring-dashboard/talent-scouting/manage/:job_vacancy_id/match-rate-setting",
  HIRING_DASHBOARD_TALENT_SCOUTING_MANAGE_INVITE:
    "/hiring-dashboard/talent-scouting/manage/:job_vacancy_id/invite",
  HIRING_DASHBOARD_TALENT_SCOUTING_MANAGE_INVITE_SAVED:
    "/hiring-dashboard/talent-scouting/manage/:job_vacancy_id/invite/saved",
  HIRING_DASHBOARD_MY_TALENT_POOL: "/hiring-dashboard/my-talent-pool",
  HIRING_DASHBOARD_MY_TALENT_POOL_SAVED: "/hiring-dashboard/my-talent-pool/saved",
  HIRING_DASHBOARD_ASSESSMENT: "/hiring-dashboard/assessment",
  HIRING_DASHBOARD_ASSESSMENT_DETAIL: "/hiring-dashboard/assessment/:job_vacancy_id",
  HIRING_DASHBOARD_AI_INTERVIEW: "/hiring-dashboard/ai-interview",
  HIRING_DASHBOARD_AI_INTERVIEW_DETAIL: "/hiring-dashboard/ai-interview/:job_vacancy_id",
  HIRING_DASHBOARD_MANAGE_VACANCY_PUBLIC: "/manage-vacancy/:vacancy_name/:vacancy_access_token",
  HIRING_DASHBOARD_BULK_UPDATE_APPLICANTS: "/hiring-dashboard/bulk-update-applicants",

  THANK_YOU_PAGE: "/thank-you-page",
  THANK_YOU_PAGE_JOB_GUARANTEE_BOOTCAMP: "/thank-you-page/job-guarantee-bootcamp",
  THANK_YOU_PAGE_MINI_INTENSIVE_COURSE: "/thank-you-page/mini-intensive-course",
  THANK_YOU_PAGE_TRIAL: "/thank-you-page/trial",
  THANK_YOU_PAGE_VIRTUAL_INTERNSHIP_EXPERIENCE: "/thank-you-page/virtual-internship-experience",
  THANK_YOU_PAGE_JOB_ACCELERATION: "/thank-you-page/job-acceleration",
  THANK_YOU_PAGE_FREE_CLASS: "/thank-you-page/free-class",

  MINI_PROJECT: "/mini-project",
  MINI_PROJECT_DETAIL: "/mini-project/:vwx_id",
  MINI_PROJECT_TASK: "/mini-project/:vwx_id/:task_id",
  USER_CONFIRMATION: "/user-confirmation",
  USER_VALIDATION: "/user-validation",

  CAREER: "/career-solutions",
  CAREER_DASHBOARD: "/career-solutions/dashboard",
  CAREER_JOB_LIST: "/career-solutions/job-applications",
  CAREER_APPLY_JOB: "/career-solutions/apply-job/:external_id",
  CAREER_HIRING_PIPELINE_INSTRUCTION: "/career-solutions/hiring-pipeline-instruction",

  ASSESSMENT_CENTER: "/assessment-center",
  ASSESSMENT_CENTER_LANDING: "/assessment-center/landing",
  ASSESSMENT_CENTER_FORM: "/assessment-center/form",
  ASSESSMENT_CENTER_PROJECT_DETAIL: "/assessment-center/project/:project_id",

  // Temporary changed from lgd to bei
  ASSESSMENT_LGD: "/assessment-center/bei",
  ASSESSMENT_LGD_FORM: "/assessment-center/bei/form",
  ASSESSMENT_RECORD: "/assessment-center/record",
  ASSESSMENT_RECORD_PREVIEW: "/assessment-center/record/:id",
  RECORDS_LIST: "/assessment-center/records-list",

  ASSESSMENT_INTERVIEW: "/assessment-center/:assessment_type",
  ASSESSMENT_INTERVIEW_FORM: "/assessment-center/:assessment_type/form",
  ASSESSMENT_INTERVIEW_RESULT: "/assessment-center/:assessment_type/:id/result",

  ASSESSMENT_INDEX: "/assessment",
  ASSESSMENT: "/assessment/:course_id",
  ASSESSMENT_ONBOARDING: "/assessment/:course_id/onboarding",
  ASSESSMENT_INTRO: "/assessment/:course_id/intro",
  ASSESSMENT_EXAM: "/assessment/:course_id/exam",
  ASSESSMENT_STIMULUS: "/assessment/:course_id/stimulus",
  ASSESSMENT_STIMULUS_QUESTIONS: "/assessment/:course_id/stimulus/questions",
  ASSESSMENT_CONFIRMATION: "/assessment/:course_id/confirmation",
  ASSESSMENT_NOT_ALLOWED: "/assessment/:course_id/not-allowed",
  ASSESSMENT_THANK_YOU: "/assessment/:course_id/thank-you",
  ASSESSMENT_IDENTITY_VERIFICATION: "/assessment/verify-identity",
  ASSESSMENT_FEEDBACK: "/assessment/:course_id/feedback",

  MODULE: "/module",
  MODULE_NOT_FOUND: "/module/:course_module_id/404",
  MODULE_FINISH: "/module/:course_module_id/finish",
  MODULE_NOT_ALLOWED: "/module/:course_module_id/401",
  MODULE_INTRO: "/module/intro/:course_module_id",
  MODULE_STIMULUS: "/module/stimulus/:module_session_id",
  MODULE_EXAM: "/module/exam/:module_session_id",

  AGREEMENT_REMINDER: "/agreement/reminder",
  AGREEMENT_EXPIRED: "/agreement/expired",
  AGREEMENT_NOT_QUALIFIED: "/agreement/not-qualified",
  REDEEM_CODE_PRAKERJA: "/redeem-code-prakerja",
  BIODATA_FULFILLMENT: "/biodata-fulfillment",
  PUBLIC_CERTIFICATES_USER: "/certificate-user/:user_id/:external_id/:course_id",

  TALENT_INTELLIGENCE: "/talent-intelligence",
  TALENT_INTELLIGENCE_PROJECTS: "/talent-intelligence/projects",
  TALENT_INTELLIGENCE_PROJECT_DETAIL: "/talent-intelligence/projects/:project_id",
  TALENT_INTELLIGENCE_PROJECT_CREATE: "/talent-intelligence/projects/create",
  TALENT_INTELLIGENCE_COMPETENCY_OVERVIEW: "/talent-intelligence/competency-overview",
  TALENT_INTELLIGENCE_COMPETENCY_OVERVIEW_DETAIL:
    "/talent-intelligence/competency-overview/:competency_category",
  TALENT_INTELLIGENCE_IDP: "/talent-intelligence/individual-development-plan",
  TALENT_INTELLIGENCE_IDP_SUGGESTION: "/talent-intelligence/individual-development-plan/suggestion",
  TALENT_INTELLIGENCE_IDP_SUGGESTION_CREATE:
    "/talent-intelligence/individual-development-plan/suggestion/create",
  TALENT_INTELLIGENCE_IDP_SUGGESTION_DETAIL:
    "/talent-intelligence/individual-development-plan/suggestion/:project_id",
  TALENT_INTELLIGENCE_TALENT_GAP_OVERVIEW: "/talent-intelligence/talent-gap-overview",
  TALENT_INTELLIGENCE_TALENT_GAP_OVERVIEW_DETAIL:
    "/talent-intelligence/talent-gap-overview/:competency_category",

  INJOURNEY_WHY_CHOOSE: "/why-injourney",
  INJOURNEY_INSIDE: "/inside-the-journey",
  INJOURNEY_ARTICLES: "/articles",
  INJOURNEY_ARTICLE_DETAIL: "/articles/:slug",

  PARAGON_ATS_FRESH_GRADUATES: "/freshgraduate-program",
  PARAGON_ATS_REFERRAL_PROGRAM: "/referral-program",
} as const;
